import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { isEmbedPortalSearch } from "@constants/embedPortal.config";
import { isAuthEntryPath } from "@constants/authEntryPaths";
import type { AppDispatch, RootState } from "@store/store";
import { setPostLoginRedirect } from "@store/slices/externalPortalSlice";

/**
 * While signed out, remembers the last in-app URL that used the embed query (excluding auth screens),
 * so post-login navigation can return there even for routes outside {@link AuthGuard}.
 */
const EmbedPostLoginPathSync = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { pathname, search, hash } = useLocation();
	const isAuthenticated = useSelector((s: RootState) => s.user.isAuthenticated);

	useEffect(() => {
		if (isAuthenticated) return;
		if (!isEmbedPortalSearch(search)) return;
		if (isAuthEntryPath(pathname)) return;
		dispatch(setPostLoginRedirect(`${pathname}${search}${hash}`));
	}, [dispatch, pathname, search, hash, isAuthenticated]);

	return null;
};

export default EmbedPostLoginPathSync;
